import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoTtdHAS from "../../../assets/images/logoTtdHAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoTtdCMS from "../../../assets/images/logoTtdCMS.png";

export const ButtonPrintVerivikasi = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocVerivikasi = ({ innerRef, item, type, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("D MMM YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return !item || item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 40px 40px 40px" }}>
        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "900px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td
                colSpan={4}
                style={{
                  border: "1px solid #000",
                  padding: "8px",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Bank BTN
                <br />
                FORM WAWANCARA
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "180px" }}>Cabang</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>DEPOK</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "180px" }}>Nama Pemohon</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>«Nama»</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>No. Kontrol</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>LIANA CLAUDIA</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>LMS No. :</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Nama Petugas</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Produk</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>NIP</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Subsidi / Non Subsidi</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
          </tbody>
        </table>

        <br />

        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "900px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td
                colSpan={5}
                style={{
                  backgroundColor: "#d9d9d9",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "6px",
                  border: "1px solid #000",
                }}
              >
                A. VALIDITAS DAN KELENGKAPAN DATA DEBITUR
              </td>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold", textAlign: "center" }}>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>A.1 Kelengkapan Data Debitur</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px" }}>Cek Kesesuaian Fisik</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px" }}>Sesuai</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Keterangan :</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>1. Identitas Diri (KTP / Paspor)</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Photo Pribadi (KTP / Pas Foto vs Aktual)</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Bentuk Tandatangan (di Form Aplikasi vs KTP)</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>

            <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold", textAlign: "center" }}>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>A.2 Validitas Data Debitur</td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>
                Valid
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Keterangan :</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Validitas KTP / Identitas Lainnya</td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>
                V
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Masa Berlaku KTP / Paspor</td>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>
                V
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
          </tbody>
        </table>

        <br />

        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "900px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td
                colSpan={4}
                style={{
                  backgroundColor: "#d9d9d9",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "6px",
                  border: "1px solid #000",
                }}
              >
                B. PENJELASAN MENGENAI PRODUK
              </td>
            </tr>
            <tr>
              <td colSpan={4} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Calon Debitur Sudah Faham akan Produk yang akan Dibeli
              </td>
            </tr>
            <tr>
              <td colSpan={2} style={{ border: "1px solid #000", padding: "4px 6px" }}>
                Ya
              </td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "60px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Tidak</td>
            </tr>
          </tbody>
        </table>

        <br />

        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "900px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td
                colSpan={4}
                style={{
                  backgroundColor: "#d9d9d9",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "6px",
                  border: "1px solid #000",
                }}
              >
                C. PENJELASAN MENGENAI HUBUNGAN ANTARA BANK - DEVELOPER - DEBITUR
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "260px" }}>C.1 Bank - Debitur : Hubungan Utang Piutang</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px", textAlign: "center" }}>Sesuai</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px", textAlign: "center" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Keterangan :</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Bank Memberikan Kredit Kepada Debitur, Debitur Membayar Pokok Hutang Beserta Bunga ke Bank Secara Mengangsur dalam Jangka Waktu yang Disepakati Bersama Antara Bank dan Debitur</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>

            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "260px" }}>C.2 Developer - Debitur : Hubungan Jual Beli</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>Sesuai</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Developer Sebagai Penjual, Debitur Sebagai Pembeli Sehingga Segala Sesuatu Mengenai Objek Rumah baik Fisik Rumah, Sarana dan Prasarana maupun Legalitasnya (Sertifikat dan IMB) Merupakan Tanggungjawab pihak Developer (Bukan Pihak Bank)</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>

            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "260px" }}>C.3 Bank - Developer : Hubungan Kerjasama</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>Sesuai</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Developer dan Bank Bekerjasama dalam Pembiayaan KPR bagi Pembeli Rumah yang Dibangun / Dijual oleh Developer</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
          </tbody>
        </table>

        <br />

        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "900px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td
                colSpan={4}
                style={{
                  backgroundColor: "#d9d9d9",
                  fontWeight: "bold",
                  textAlign: "center",
                  padding: "6px",
                  border: "1px solid #000",
                }}
              >
                D. KETENTUAN KPR SUBSIDI
              </td>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0", fontWeight: "bold", textAlign: "center" }}>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>D.1 Kesesuaian Kualifikasi Calon Debitur</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px" }}>Ya</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", width: "30px" }}>Tidak</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>Keterangan :</td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>D.1 Gaji Pokok Calon Debitur Sesuai dengan KPR Bersubsidi yang Berlaku</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>D.2 Calon Debitur Belum Memiliki Rumah</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}>D.3 Calon Debitur Belum Pernah Memperoleh Fasilitas KPR Bersubsidi</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px", textAlign: "center" }}>V</td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
              <td style={{ border: "1px solid #000", padding: "4px 6px" }}></td>
            </tr>
          </tbody>
        </table>

        <br />

        <table style={{ borderCollapse: "collapse", width: "100%", maxWidth: "900px", margin: "0 auto" }}>
          <tbody>
            <tr>
              <td
                colSpan={3}
                style={{
                  border: "1px solid #000",
                  borderBottom: "none",
                  padding: "8px 6px",
                }}
              >
                Pada hari ini Tanggal ......... Saya/Kami yang bertandatangan dibawah ini telah memberikan keterangan data yang valid dalam wawancara yang dilakukan oleh Loan Service PT. Bank Tabungan Negara (Persero) Cabang ......... Untuk keperluan penilaian atas kelayakan kredit yang Saya/Kami ajukan.
                <br />
                <br />
                Saya/Kami telah memahami produk yang akan Saya/Kami ambil serta hubungan antara Bank BTN - Developer - Debitur dalam pengambilan KPR ini.
              </td>
            </tr>
            <tr>
              <td style={{ border: "1px solid #000", height: "60px", verticalAlign: "bottom", textAlign: "center", padding: "4px 6px" }}>
                Loan Service / Petugas Wawancara
                <br />
                <br />
                <br />
                <br />
                BANK BTN
              </td>
              <td style={{ border: "1px solid #000", height: "60px", verticalAlign: "bottom", textAlign: "center", padding: "4px 6px" }}>Pemohon</td>
              <td style={{ border: "1px solid #000", height: "60px", verticalAlign: "bottom", textAlign: "center", padding: "4px 6px" }}>
                Nama Pasangan : «Pasangan»
                <br />
                <br />
                Nama Pemohon : «Nama»
              </td>
            </tr>
            <tr>
              <td colSpan={3} style={{ border: "1px solid #000", textAlign: "center", fontWeight: "bold", padding: "4px 6px" }}>
                Nama : LIANA CLAUDIA
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
